import type {BulkOperationSelection} from '../types/BulkOperationActionCallback';

/** Shared availability policy for the footer, scope selector, and synchronous submission guard. */
export function getAvailableBulkOperationTargets(selection: BulkOperationSelection) {
  const query = selection.query;
  return {
    selected:
      selection.recordIds.length > 0
        ? {type: 'selected' as const, recordIds: [...selection.recordIds]}
        : null,
    filtered:
      query.state === 'ready' && query.dataQueryId.length > 0 && query.totalCount > 0
        ? {type: 'filtered' as const, dataQueryId: query.dataQueryId, totalCount: query.totalCount}
        : null,
  };
}
